import { render, staticRenderFns } from "./BotObjects.vue?vue&type=template&id=1ebd5412&scoped=true"
import script from "./BotObjects.vue?vue&type=script&lang=js"
export * from "./BotObjects.vue?vue&type=script&lang=js"
import style0 from "./BotObjects.vue?vue&type=style&index=0&id=1ebd5412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebd5412",
  null
  
)

export default component.exports